<div class="tr-card">
    <div class="tr-card-blur"></div>
    <div class="tr-card-noise"></div>
    <div class="tr-card-container">
        <div class="tr-card-container-row1">membership</div>
        <div class="tr-card-container-spacer"></div>
        <div class="tr-card-container-row2">learning in motion</div>
        <div class="tr-card-container-row3">kinetek</div>
    </div>
</div>